import React, { useContext } from "react";
import { StoreContext } from "../../Context/StoreContext";
import { deleteRoom } from "../../actions/roomAction";
import DeleteModel from "../../VibehutUI/DeleteModel";
import { useHistory } from "react-router-dom";

export default function DeleteRoom({ isOpen, setIsOpen, room }) {
  const { state, dispatch } = useContext(StoreContext);
  const history = useHistory();
  const {
    auth: {
      user: { token },
    },
    room: { isFetching },
  } = state;

  const handleDelete = () => {
    deleteRoom(room._id, token, dispatch).then(() => {
      setIsOpen(false);
      history.push("/rooms");
    });
  };

  return (
    <DeleteModel
      handleDelete={handleDelete}
      title={room.name}
      isFetching={isFetching}
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      text={`Are you sure you want to delete <span className="text-black dark:text-gray-100">
                  "${room.name}"?
                </span>`}
    />
  );
}
